export default async ({ route, redirect, $aProxy, app, state }) => {

  if (app.store.state.langUpdated) {
    app.store.commit('SET_LANG_UPDATING', false)
    return
  }
  const query = route.query
  await $aProxy.get(`/url-translator/?url=${encodeURI(route.path)}&locations=${route.query.locations ?? ''}`).then((resp) => {
    const data = resp.data

    switch (data.status) {
      case 301:
        if (!data?.url) {
          break
        }
        let fullPath = data.url
        if (['search', 'destinations', 'search_with_boat', 'search_with_boat_charter'].includes(route.name)) {
          if (data.locations) {
            query.locations = data.locations
          }
          fullPath = app.router.resolve({ path: fullPath, query }).href
        }
        return redirect(301, fullPath)
      case 404:
        return redirect(301, `/${route.params.lang}/destinations/`)
      default:
        break
    }
  }).catch((e) => {

  })
}
